<template>
  <div class="aws-sku-product-spec-edit">
    <div class="aws-sku-product-spec-edit-image">
      <div class="aws-sku-product-spec-edit-image-wrapper">
        <el-image
          :src="defaultImageUrl"
          :preview-src-list="[defaultImageUrl]"
        />
      </div>

      <div
        v-if="!disabled && editImage"
        class="aws-sku-product-spec-edit-image-button"
      >
        <el-button size="small" @click="editImageOpts.visible = true">
          {{ $l('INDEX.evg_sku_label_edit_picture') || '编辑图片' }}
        </el-button>
      </div>
    </div>

    <div class="aws-sku-product-spec-edit-info">
      <el-form
        ref="form"
        size="small"
        :model="formData"
        :rules="rules"
        :disabled="disabled"
        :validate-on-rule-change="false"
        label-position="top"
      >
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('INDEX.form_label_awsSkuSpec_specNo') || '规格编号'"
            >
              <el-col :span="12" class="px-0">
                <el-input v-model="formData.specNo" readonly />
              </el-col>
              <el-col :span="12" class="px-0">
                <div style="padding-left: 10px;">
                  <span>
                    {{ '系统自动生成的编号，不需手工录入' }}
                  </span>
                </div>
              </el-col>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_awsSkuSpec_specName') || '规格名称'"
              required
            >
              <el-input v-model="specName" readonly />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.form_label_awsSkuSpec_specNameEn') || '英文名称'
              "
              required
            >
              <el-input v-model="specNameEn" readonly />
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item
              :label="
                $l('INDEX.form_label_awsSkuSpec_specNameDictCode') || '名称字典'
              "
              prop="specNameDictCode"
            >
              <dict-select
                v-model="formData.specNameDictCode"
                :placeholder="
                  $l('INDEX.form_placeholder_awsSkuSpec_specNameDictCode') ||
                    '请选择名称字典'
                "
                url="/ecom/amz/sku/spec/nameSelect"
                clearable
                filterable
                @loaded="(items) => (amzSkuSpecNameItems = items)"
                @change="amzSkuSpecNameChange"
              />
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="
                $l('INDEX.form_label_awsSkuSpec_hasGoodsTech') ||
                  '是否填写成品工艺'
              "
              prop="hasGoodsTech"
              style="margin-bottom: 8px !important;"
            >
              <el-radio-group
                v-model="formData.hasGoodsTech"
                @change="hasGoodsTechChange"
              >
                <el-radio-button label="Y">
                  {{ $l('INDEX.form_label_awsSkuSpec_hasGoodsTech_Y') || '是' }}
                </el-radio-button>
                <el-radio-button label="N">
                  {{ $l('INDEX.form_label_awsSkuSpec_hasGoodsTech_N') || '否' }}
                </el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :span="20">
            <el-form-item
              :label="
                $l('INDEX.form_label_awsSkuSpec_goodsTechDictCode') ||
                  '成品工艺'
              "
              prop="goodsTechDictCode"
            >
              <dict-select
                v-model="formData.goodsTechDictCode"
                :placeholder="
                  $l('INDEX.form_placeholder_awsSkuSpec_goodsTechDictCode') ||
                    '请选择成品工艺'
                "
                url="/ecom/amz/sku/spec/techSelect"
                :disabled="!hasGoodsTech"
                clearable
                filterable
                @loaded="(items) => (amzSkuSpecTechItems = items)"
                @change="amzSkuSpecTechChange"
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_awsSkuSpec_specDesc') || '中文描述'"
            >
              <el-input
                v-model="formData.specDesc"
                :placeholder="
                  $l('INDEX.form_placeholder_awsSkuSpec_specDesc') ||
                    '请输入中文描述'
                "
                :maxlength="250"
                show-word-limit
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.form_label_awsSkuSpec_specDescEn') || '英文描述'
              "
            >
              <el-input
                v-model="formData.specDescEn"
                :placeholder="
                  $l('INDEX.form_placeholder_awsSkuSpec_specDescEn') ||
                    '请输入英文描述'
                "
                :maxlength="250"
                show-word-limit
              />
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('INDEX.form_label_awsSkuSpec_goodsLength') || '长'"
              prop="goodsLength"
            >
              <el-input-number
                v-model="formData.goodsLength"
                :placeholder="
                  $l('INDEX.form_placeholder_awsSkuSpec_goodsLength') ||
                    '请输入长'
                "
                controls-position="right"
                :min="0"
                :step="0.01"
                :precision="2"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('INDEX.form_label_awsSkuSpec_goodsWidth') || '宽'"
              prop="goodsWidth"
            >
              <el-input-number
                v-model="formData.goodsWidth"
                :placeholder="
                  $l('INDEX.form_placeholder_awsSkuSpec_goodsWidth') ||
                    '请输入宽'
                "
                controls-position="right"
                :min="0"
                :step="0.01"
                :precision="2"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('INDEX.form_label_awsSkuSpec_goodsHeight') || '高'"
              prop="goodsHeight"
            >
              <el-input-number
                v-model="formData.goodsHeight"
                :placeholder="
                  $l('INDEX.form_placeholder_awsSkuSpec_goodsHeight') ||
                    '请输入高'
                "
                controls-position="right"
                :min="0"
                :step="0.01"
                :precision="2"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item
              :label="$l('INDEX.form_label_awsSkuSpec_specUnit') || '尺寸单位'"
              prop="specUnit"
            >
              <dict-select
                v-model="formData.specUnit"
                :placeholder="
                  $l('INDEX.form_placeholder_awsSkuSpec_specUnit') ||
                    '请选择尺寸单位'
                "
                url="/master/common/dict/biz"
                :body="specUnitBody"
                clearable
                filterable
              />
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item
              :label="$l('INDEX.form_label_awsSkuSpec_specQty') || '规格数量'"
              prop="specQty"
            >
              <el-input-number
                v-model="formData.specQty"
                :placeholder="
                  $l('INDEX.form_placeholder_awsSkuSpec_specQty') ||
                    '请输入规格数量'
                "
                controls-position="right"
                :precision="0"
                :min="0"
                :step="1"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <AwsSkuEditImages
      :visible.sync="editImageOpts.visible"
      :amzSkuCode="amzSkuCode"
      @check="checkImage"
    />

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      v-if="backDialogVisible"
      :visible.sync="backDialogVisible"
      width="30%"
      @close="() => (backDialogVisible = false)"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import lodash from 'lodash'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import AwsSkuEditImages from '../aws-sku-edit-images'
export default {
  components: { AwsSkuEditImages },
  props: {
    disabled: { type: Boolean, default: false },
    editImage: { type: Boolean, default: true },
    isSingle: { type: Boolean, default: true },
    amzSkuCode: { type: String, default: '' },
    amzSkuSpecCode: { type: String, default: '' },
    sku: { type: Object, default: () => ({}) },
  },
  mixins: [EditLoading],
  data() {
    return {
      backDialogVisible: false,
      formData: {
        specNameDictText: '',
        specNameDictTextEn: '',
        hasGoodsTech: 'N',
        defaultImageCode: '',
        defaultImageUrl: '',
        goodsTechDictCode: '',
        goodsTechDictText: '',
        goodsTechDictTextEn: '',
      },
      amzSkuSpecNameItems: [],
      amzSkuSpecTechItems: [],
      specUnitBody: { dictType: 'specUnit' },
      editImageOpts: { visible: false },
    }
  },
  computed: {
    hasGoodsTech() {
      return lodash.isEqual(this.formData.hasGoodsTech, 'Y')
    },
    rules() {
      return {
        specNameDictCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_awsSkuSpec_specNameDictCode') ||
              '请选择名称字典',
            trigger: 'change',
          },
        ],
        hasGoodsTech: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_awsSkuSpec_hasGoodsTech') ||
              '请选择是否填写成品工艺',
            trigger: 'change',
          },
        ],
        goodsTechDictCode: [
          {
            required: this.hasGoodsTech,
            message:
              this.$l('INDEX.form_placeholder_awsSkuSpec_goodsTechDictCode') ||
              '请选择成品工艺',
            trigger: 'change',
          },
        ],
        goodsLength: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_awsSkuSpec_goodsLength') ||
              '请输入长',
            trigger: 'blur',
          },
        ],
        goodsWidth: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_awsSkuSpec_goodsWidth') ||
              '请输入宽',
            trigger: 'blur',
          },
        ],
        goodsHeight: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_awsSkuSpec_goodsHeight') ||
              '请输入高',
            trigger: 'blur',
          },
        ],
        specUnit: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_awsSkuSpec_specUnit') ||
              '请选择尺寸单位',
            trigger: 'change',
          },
        ],
        specQty: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_awsSkuSpec_specQty') ||
              '请输入规格数量',
            trigger: 'blur',
          },
        ],
      }
    },
    defaultImageUrl() {
      const defaultImageUrl = this.formData.defaultImageUrl
      return this.$osscdn(defaultImageUrl) || '/image/static/img/nopic.jpg'
    },
    amzSkuSpecNameMaps() {
      return lodash.keyBy(this.amzSkuSpecNameItems, 'value')
    },
    amzSkuSpecTechMaps() {
      return lodash.keyBy(this.amzSkuSpecTechItems, 'value')
    },
    goodsSize() {
      const goodsLength = Number(this.formData.goodsLength || 0).toString()
      const goodsWidth = Number(this.formData.goodsWidth || 0).toString()
      const goodsHeight = Number(this.formData.goodsHeight || 0).toString()
      const specUnit = this.formData.specUnit || ''

      const size = [
        goodsLength || '0',
        goodsWidth || '0',
        goodsHeight <= 0 ? null : goodsHeight,
      ]
        .filter(Boolean)
        .join('*')
      return [size, specUnit].filter(Boolean).join('')
    },
    skuGoodsName() {
      const { goodsName, spuGoodsName, goodsColor } = this.sku

      if (this.isSingle) {
        return [spuGoodsName, goodsColor, this.goodsSize]
          .filter(Boolean)
          .join('')
      }
      return goodsName
    },
    skuGoodsNameEn() {
      const { goodsNameEn, spuGoodsNameEn, goodsColorEn } = this.sku

      if (this.isSingle) {
        return [spuGoodsNameEn, goodsColorEn, this.goodsSize]
          .filter(Boolean)
          .join(' ')
      }

      return goodsNameEn
    },
    specName() {
      const { specNameDictText, specDesc } = this.formData
      const goodsTechDictText = this.hasGoodsTech
        ? this.formData.goodsTechDictText
        : ''

      if (this.isSingle) {
        return lodash
          .map([this.skuGoodsName, goodsTechDictText], lodash.trim)
          .filter(Boolean)
          .join(' ')
      }

      return lodash
        .map([specNameDictText, goodsTechDictText, specDesc], lodash.trim)
        .filter(Boolean)
        .join(' ')
    },
    specNameEn() {
      const { specNameDictTextEn, specDescEn } = this.formData
      const goodsTechDictTextEn = this.hasGoodsTech
        ? this.formData.goodsTechDictTextEn
        : ''

      if (this.isSingle) {
        return lodash
          .map([this.skuGoodsNameEn, goodsTechDictTextEn], lodash.trim)
          .filter(Boolean)
          .join(' ')
      }

      return lodash
        .map([specNameDictTextEn, goodsTechDictTextEn, specDescEn], lodash.trim)
        .filter(Boolean)
        .join(' ')
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    amzSkuSpecNameChange(val) {
      const item = val ? this.amzSkuSpecNameMaps[val] : {}
      this.formData.specNameDictText = item.specNameDictText
      this.formData.specNameDictTextEn = item.specNameDictTextEn
    },
    hasGoodsTechChange(val) {
      if (!lodash.isEqual(val, 'Y')) {
        this.formData.goodsTechDictCode = ''
        this.formData.goodsTechDictText = ''
        this.formData.goodsTechDictTextEn = ''
      }
    },
    amzSkuSpecTechChange(val) {
      const item = val ? this.amzSkuSpecTechMaps[val] : {}
      this.formData.goodsTechDictText = item.goodsTechDictText
      this.formData.goodsTechDictTextEn = item.goodsTechDictTextEn
    },
    checkImage({ displayImageCode, displayImageUrl }) {
      this.formData.defaultImageCode = displayImageCode
      this.formData.defaultImageUrl = displayImageUrl
      this.editImageOpts = { visible: false }
    },
    async getData() {
      if (!this.amzSkuSpecCode) return

      const res = await this.$api
        .ecomAmzSkuSpecDetailApi({ amzSkuSpecCode: this.amzSkuSpecCode })
        .catch(() => null)
      if (!res) return

      this.formData = res.body || {}
    },
    async save() {
      if (!(await validate.formValidate([this.$refs.form]))) {
        return (this.backDialogVisible = false)
      }
      this.loadingOpen()
      const res = await this.$api
        .ecomAmzSkuSpecSaveApi({
          ...this.formData,
          specName: this.specName,
          specNameEn: this.specNameEn,
          amzSkuCode: this.amzSkuCode,
        })
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功',
        type: 'success',
      })

      this.$emit('reload')
      this.close()
    },
    cancel() {
      if (this.disabled) return this.close()
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
      this.$emit('reload')
    },
  },
}
</script>

<style lang="scss" scoped>
.aws-sku-product-spec-edit {
  display: flex;
  gap: 15px;
  .aws-sku-product-spec-edit-image {
    .aws-sku-product-spec-edit-image-wrapper {
      padding: 6px;
      border-radius: 5px;
      border: 1px dashed #cecece;
      display: flex;
      margin-bottom: 10px;
      .el-image {
        width: 120px;
        height: 120px;
        border-radius: 3px;
      }
    }
    .aws-sku-product-spec-edit-image-button {
      .el-button {
        width: 100%;
      }
    }
  }
}
</style>
